import { create } from "zustand";
import { collectionDoc } from "@/api/collectionRef/collectionOperations";
import { profileLunarProps } from "@/features/profile/types/profileLunar";

interface ProfileLunarState {
  profileLunar: profileLunarProps | null;
  loading: boolean;
  error: Error | null;
  fetchProfileLunar: (uid: string) => Promise<void>;
}

export const useProfileLunarStore = create<ProfileLunarState>((set) => ({
  profileLunar: null,
  loading: false,
  error: null,
  fetchProfileLunar: async (uid: string) => {
    set({ loading: true });

    try {
      const doc = await collectionDoc.profileLunar(uid);
      if (doc.exists) {
        set({ profileLunar: doc.data() as profileLunarProps, error: null });
      } else {
        set({ error: new Error("No such document!") });
      }
    } catch (err) {
      set({ error: err.message });
    } finally {
      set({ loading: false });
    }
  },
}));
